//
//
//
//
//
//
//
//
//
//
//
//
//

import { Upload } from '@/constant/componentConfig'

export default {
  props: {
    options: {
      type: Object,
      default: () => ({}),
    },
  },

  data () {
    return { formData: {} }
  },

  computed: {
    noNeedFlag () {
      return +this.options?.bmbMbDetailItem?.fjyqdm !== 1
    },

    renderData () {
      const configData = this.options?.bmbMbDetailItem

      return [
        new Upload({
          row: true,
          value: 'attachmentWids',
          prefixPosition: 'top',
          required: configData.fjsfbtdm === '1',
          readonly: true,
          fileCount: +configData?.fjgssx || 0,
          label: '附件',
          params: { ksWid: this.options?.ksxxItem?.wid },
          maxSize: +configData?.fjdxsx * 1024,
        }),
      ]
    },
  },

  watch: {
    options: {
      handler (val) {
        if (Object.keys(val)?.length) {
          this.formData.attachmentWids = val?.fjList?.map((el) => {
            const temp = {
              url: el.fjdz,
              fileName: el.fjmc,
              name: el.fjmc,
              status: 'done',
            }

            return {
              ...temp,
              file: temp,
            }
          }) || []
        }
      },
      deep: true,
      immediate: true,
    },
  },
}
